
import NotificationItem from "./NotificationItem";
import "./Notifications.css";
import empty_state from "../../images/empty_state.svg"

function NotificationsList({ notifications = [], onClick }) {
    if (notifications.length === 0) {
        return (
            <div className="notifications-empty">
                <img className="empty_state" src={empty_state} />
                Não tem notificações
            </div>
        );
    }
    const clickItem = (id) => {
        onClick(id)
    }

    return (
        <section className="notifications-list">
            {notifications.map((notification) => (
                <NotificationItem
                    key={notification.id}
                    notification={notification}
                    onClick={() => clickItem(notification.id)}
                />
            ))}
        </section>
    );
}

export default NotificationsList;